import React, { useState } from "react";
import "./App.css";
import SearchBar from "./components/SearchBar.jsx";
import Cards from "./components/Cards.jsx";

const apiKey = process.env.REACT_APP_API_KEY;
function App() {
  const [cities, setCities] = useState([]);

  function agregar(city) {
    setCities((prevCities) => {
      return [city, ...prevCities];
    });
  }
  function eliminar(id) {
    setCities((oldCities) => oldCities.filter((c) => c.id !== id));
  }

  function onSearch(ciudad) {
    fetch(
      `https://api.openweathermap.org/data/2.5/weather?q=${ciudad}&appid=${apiKey}&units=metric`
    )
      .then((r) => r.json())
      .then((recurso) => {
        console.log(recurso);
        if (recurso.main !== undefined) {
          const ciudad = {
            country: recurso.sys.country,
            min: Math.round(recurso.main.temp_min),
            max: Math.round(recurso.main.temp_max),
            img: recurso.weather[0].icon,
            id: recurso.id,
            wind: recurso.wind.speed,
            temp: recurso.main.temp,
            name: recurso.name,
            weather: recurso.weather[0].main,
            clouds: recurso.clouds.all,
            latitud: recurso.coord.lat,
            longitud: recurso.coord.lon,
          };
          setCities((oldCities) => [...oldCities, ciudad]);
        } else {
          alert("Ciudad no encontrada");
        }
      });
  }
  return (
    <div className="App">
      {/* Tu código acá: */}
      <SearchBar onSearch={onSearch} />
      <Cards cities={cities} onClose={eliminar} />
    </div>
  );
}
export default App;
